import { render, staticRenderFns } from "./HistoryPackageHistory.vue?vue&type=template&id=3df5b60c&scoped=true"
import script from "./HistoryPackageHistory.vue?vue&type=script&lang=js"
export * from "./HistoryPackageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5b60c",
  null
  
)

export default component.exports